import { Directive, ElementRef, OnDestroy, Renderer2, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { getCatalogStyles, getCategoryAttachments } from '../../../store/category-page.selectors';

import { getGridType } from '@pages/category/store/grid-type/grid-type.selectors';
import { GridType, GridTypes } from '@shared/models/grid-type.model';

@Directive({
    selector: '[categoryPageStyles]',
})

/**
 * Directiva para aplicar diseños a las parrillas
 */
export class CategoryPageStylesDirective implements OnDestroy, AfterViewInit {
    private readonly onDestroy$ = new Subject<void>();

    constructor(
        private readonly store: Store,
        private readonly elementRef: ElementRef,
        private readonly renderer: Renderer2
    ) {

    }

    public ngAfterViewInit() {
        combineLatest([
            this.store.select(getCategoryAttachments),
            this.store.select(getCatalogStyles),
            this.store.select(getGridType),
        ]).pipe(
            takeUntil(this.onDestroy$)
        ).subscribe(([attachments, catalogStyles, gridType]: [ any, Record<string, string>, GridType]) => {
            if (attachments?.some((attachment: any) => attachment.name === 'background_color') && catalogStyles?.backgroundColor && gridType === GridTypes.ZARA_STUDIO) {
                this.renderer.setStyle(this.elementRef.nativeElement, 'background-color', catalogStyles.backgroundColor);
                this.renderer.setStyle(this.elementRef.nativeElement, 'color', catalogStyles.fontColor);
                this.renderer.addClass(this.elementRef.nativeElement, 'grid-wrap-custom');
            } else {
                this.renderer.removeStyle(this.elementRef.nativeElement, 'background-color');
                this.renderer.removeStyle(this.elementRef.nativeElement, 'color');
                this.renderer.removeClass(this.elementRef.nativeElement, 'grid-wrap-custom');
            }
        });
    }

    public ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
